<script setup lang="ts">
import { reactive } from 'vue'
import { X } from 'lucide-vue-next'
import { useI18n } from 'vue-i18n'
import { Sheet, SheetContent, SheetHeader } from '@/components/ui/sheet'
import { Input } from '@/components/ui/input'
import { DialogClose } from '@/components/ui/dialog'
import BaseIcon from '@/components/ui/icon/BaseIcon.vue'
import { usePCSSearchInput } from '@/services/usePCSSearchInput'

const { t } = useI18n()
const emits = defineEmits(['closeMobileNav'])

const state = reactive({
	isOpen: false,
	showCloseButton: false,
})

const { inputValue, isInputNotEmpty, navigateToSearch, clearInputValue } =
	usePCSSearchInput()

const openSheet = () => {
	state.isOpen = true
}
const closeSheet = () => {
	state.isOpen = false
}

const handleOpenChange = () => {
	navigateToSearch()
	closeSheet()
	emits('closeMobileNav')
}
</script>

<template>
	<Sheet v-model:open="state.isOpen">
		<div
			@click="openSheet"
			class="mr-8px flex cursor-pointer items-center justify-center rounded-lg bg-transparent p-[10px] hover:bg-n-100 lg:hidden"
		>
			<BaseIcon name="search-v2" class="h-24px w-24px fill-black" />
		</div>
		<SheetContent
			class="flex w-full flex-col bg-white"
			side="right"
			:showCloseButton="state.showCloseButton"
		>
			<SheetHeader>
				<div
					class="flex w-full items-center gap-16px border-b border-n-100 px-20px py-close-friends"
				>
					<DialogClose>
						<div
							class="flex items-center rounded-full p-4px hover:bg-n-100 active:bg-n-200"
						>
							<BaseIcon
								name="chevron-left"
								class="m-0 h-24px w-24px text-n-950"
							></BaseIcon>
						</div>
					</DialogClose>
					<div class="relative flex w-full items-center">
						<Input
							v-model="inputValue"
							@keyup.enter="handleOpenChange"
							type="text"
							:placeholder="t('pcs_search_placeholder')"
							class="typography-b2-reg rounded-full border-2 border-n-950 py-[10px] pl-[52px] pr-48px text-n-950 mdp:pl-24px mdp:pr-[100px]"
						></Input>

						<div
							v-if="isInputNotEmpty"
							@click="clearInputValue"
							class="absolute right-16px top-1/2 -translate-y-1/2 cursor-pointer rounded-full bg-n-100 p-[3.75px] hover:bg-n-200 active:bg-n-300 mdp:right-[58px] mdp:bg-transparent mdp:hover:bg-n-100 mdp:active:bg-n-300"
						>
							<X class="h-16px w-16px text-white mdp:text-n-950" />
						</div>

						<!-- tablet search icon -->
						<div
							@click="handleOpenChange"
							class="absolute right-12px hidden h-32px w-32px cursor-pointer items-center justify-center rounded-full bg-o-500 hover:bg-o-600 mdp:flex"
						>
							<BaseIcon name="search-v2" class="h-16px w-16px fill-white" />
						</div>
						<!-- mobile search icon -->
						<div
							@click="handleOpenChange"
							class="absolute left-[12px] flex h-32px w-32px cursor-pointer items-center justify-center rounded-full hover:bg-n-100 mdp:hidden"
						>
							<BaseIcon name="search-v2" class="h-16px w-16px fill-black" />
						</div>
					</div>
				</div>
			</SheetHeader>
		</SheetContent>
	</Sheet>
</template>
